import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                py: 2,
                px: 2,
                mt: 'auto',
                backgroundColor: '#fff',
                borderTop: '1px solid rgba(0, 31, 63, 0.08)',
                textAlign: 'center'
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: '#666',
                    fontSize: '0.85rem',
                }}
            >
                {'Copyright © '}
                <Link
                    href="#"
                    sx={{
                        textDecoration: 'none',
                        fontWeight: 600,
                        color: '#001F3F',
                        '&:hover': {
                            color: '#3A6B7E',
                        }
                    }}
                >
                    IESS
                </Link>
                {` ${currentYear}. Todos los derechos reservados.`}
            </Typography>
        </Box>
    );
};

export default Footer;
